import React, { useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Translator from "Languages/Utility/Translator";
import { read } from "Helpers/LocalStorage";
import TicketsService from "Services/http/endpoints/tickets/TicketsService";
import StatusHandler from "Helpers/StatusHandler";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { Grid, Typography, useTheme } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import fileDownload from "js-file-download";
import showNotify from "Helpers/Notify";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import TicketingMessage from "Components/TicketingMessage/TicketingMessage";
import TicketTextBox from "Components/TicketTextBox/TicketTextBox";
import { push } from "Helpers/History";
import getFileTypeIcon from "Helpers/fileTypeIcon";

function TicketDetails(props) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [newText, setNewText] = useState("");
  const ticketId = props.location.pathname.split(
    "/dashboard/support/tickets/",
  )[1];

  const onClear = () => {
    setNewText("");
    setSelectedFile(null);
  };

  useEffect(() => {
    (async () => {
      await getData();
    })();
  }, [props.location.pathname]);

  const getData = async () => {
    onClear();
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: ticketId,
        SIdForm: 0,
        SAction: 0,
      };
      const response = await TicketsService.getTicketDetails(params);
      const err = StatusHandler(response);
      if (!err.isFail) {
        setData(response.data.Value);
        setTimeout(() => {
          const objDiv = document.getElementById("ticket-details");
          objDiv.scrollTop = objDiv.scrollHeight;
        }, 300);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onClick = async (file) => {
    const params = {
      KeyGroup: read("groupKey"),
      KeyUser: read("userKey"),
      TicketId: ticketId,
      Id: file.Id,
      Type: file.Type,
      SIdForm: 0,
      SAction: 0,
    };
    TicketsService.getTicketAttachment(params).then((response) => {
      fileDownload(response.data, file.FileName);
    });
  };

  const handleNewMessage = (e) => {
    setNewText(e.target.value);
  };

  const onChangeFile = ({ target }) => {
    setSelectedFile(target.files[0]);
  };

  const onDeleteFile = (e) => {
    e.preventDefault();
    setSelectedFile(null);
  };

  const onSaveMessage = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (newText && newText !== "") {
      try {
        let bodyFormData = new FormData();
        bodyFormData.append("KeyGroup", read("groupKey"));
        bodyFormData.append("KeyUser", read("userKey"));
        bodyFormData.append("Description", newText);
        bodyFormData.append("SIdForm", 0);
        bodyFormData.append("Id", ticketId);
        bodyFormData.append("SAction", 0);
        bodyFormData.append("Attachment", selectedFile);

        const response = await TicketsService.postTicketMessage(bodyFormData);
        let err = StatusHandler(response);
        if (!err.isFail) {
          await getData();
        }
      } catch (e) {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
      }
    } else {
      if (newText === "" && selectedFile) {
        showNotify({
          text: t("needDescription"),
          customClass: "warning",
        });
      } else {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
      }
    }
    setLoading(false);
  };

  return (
    <div className={direction === "rtl" ? "text-right" : "text-left"}>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-2">
        <PageTitle title={<Translator id="ticket_details" />} />
        <div className="top-buttons">
          <MuiButton
            color="secondary"
            onClick={() => push("/dashboard/support/tickets/")}
            title={t("backToList")}
            innerIcon={<Icons.ArrowReturnLeft />}
          />
        </div>
      </div>
      {data?.IsClosed && (
        <div className="closedTicket">
          <div className="closedTicket-icon">
            <Icons.XCircleFill />
          </div>
          <small>{t("closedTicket")}</small>
        </div>
      )}
      <MuiPaper className="ticket-page-info">
        {data && (
          <Grid container className="p-2">
            <Grid xs={12} item className="ticket-detail-info">
              <span>{`${t("title")} :`}</span>
              <p>{data.Title}</p>
            </Grid>
            <Grid xs={12} item className="ticket-detail-info">
              <span>{`${t("description")} :`}</span>
              <p>{data.Descript}</p>
            </Grid>
            {data.File && (
              <Grid className="file-attachment">
                <Grid className="d-flex flex-row g-2">
                  {`${t("fileAttachment")} :`}
                  <p>{data.File.FileName}</p>
                </Grid>
                <MuiButton
                  className="link"
                  title={t("viewFile")}
                  innerIcon={getFileTypeIcon(data.File.FileName)}
                  disabled={data.File ? false : true}
                  onClick={() => onClick(data.File)}
                />
              </Grid>
            )}
          </Grid>
        )}
      </MuiPaper>
      <MuiPaper className="mt-3">
        <TicketingMessage side={"user"} data={data} onClick={onClick} />
      </MuiPaper>
      {!loading && data && !data.IsClosed && (
        <TicketTextBox
          data={data}
          text={newText}
          changeText={handleNewMessage}
          onChange={onChangeFile}
          selectedFile={selectedFile}
          onDeleteFile={onDeleteFile}
          onDone={onSaveMessage}
        />
      )}
    </div>
  );
}

export default TicketDetails;
